/** Parâmetros de reveal-on-scroll (referência tis.ao / viaagenciadigital). */

export const REVEAL_Y = 40

export const REVEAL_DURATION = 0.75

export const REVEAL_EASE = [0.22, 1, 0.36, 1]

export const REVEAL_STAGGER = 0.1

export const REVEAL_CARD_STAGGER = 0.15

export const REVEAL_IMAGE_DELAY = 0.15

export const REVEAL_IMAGE_Y = 32

export const REVEAL_IMAGE_SCALE = 1.08

export const REVEAL_IMAGE_CLIP_DURATION = 0.9

export const REVEAL_IMAGE_SCALE_DURATION = 1.1

export const REVEAL_VIEWPORT = { once: false, margin: '0px 0px -5% 0px' }



export const revealTransition = (delay = 0, revealed = true) => ({
  duration: revealed ? REVEAL_DURATION : 0.35,
  delay: revealed ? delay : 0,
  ease: REVEAL_EASE,
})



export const imageRevealTransition = (delay = REVEAL_IMAGE_DELAY, duration = REVEAL_IMAGE_CLIP_DURATION) => ({

  duration,

  delay,

  ease: REVEAL_EASE,

})


